export default [
  {
    _name: 'DashboardTiles',
    _children: [
      {
        _name: 'DashboardTile',
        name: 'Invite',
        to: '/customers/contacts/invite',
        fontIcon: 'fa fa-paper-plane',
      },
      {
        _name: 'DashboardTile',
        name: 'Sent',
        to: '/customers/contacts/sent',
        fontIcon: 'fa fa-check-circle',
      },
      {
        _name: 'DashboardTile',
        name: 'Product Type Access',
        to: '/customers/product-access',
        fontIcon: 'fa fa-eye',
      }
    ]
  }
]
